import { Unionize } from "./generic";

export const GeolocationPositionErrorCode = [
  GeolocationPositionError.PERMISSION_DENIED,
  GeolocationPositionError.POSITION_UNAVAILABLE,
  GeolocationPositionError.TIMEOUT,
] as const;
export type GeolocationPositionErrorCode = Unionize<typeof GeolocationPositionErrorCode>;

export const GeolocationErrorCodeMap = {
  [GeolocationPositionError.PERMISSION_DENIED]: "PERMISSION_DENIED",
  [GeolocationPositionError.POSITION_UNAVAILABLE]: "POSITION_UNAVAILABLE",
  [GeolocationPositionError.TIMEOUT]: "TIMEOUT",
  /**
   * While not one of the errors provided by the spec - if something unknown goes wrong
   * we still want to indicate something to the user.
   */
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
  /**
   * For indicating the browser or device does not support the Geolocation API
   */
  NO_SUPPORT: "NO_SUPPORT",
} as const;

export const GeolocationErrorName = Object.values(GeolocationErrorCodeMap);
export type GeolocationErrorName = Unionize<typeof GeolocationErrorName>;

export const GeolocationErrorLabel: Record<GeolocationErrorName, string> = {
  PERMISSION_DENIED: "You have not allowed location access",
  POSITION_UNAVAILABLE: "Could not determine location",
  TIMEOUT: "Timed out when getting current location",
  UNKNOWN_ERROR: "An error occurred when trying to determine location",
  NO_SUPPORT: "Geolocation is not supported by your browser or device",
};

export const getGeolocationErrorName = (numericCode: number): GeolocationErrorName => {
  if (numericCode >= 1 && numericCode <= 3) {
    return GeolocationErrorCodeMap[numericCode as GeolocationPositionErrorCode];
  }
  return GeolocationErrorCodeMap.UNKNOWN_ERROR;
};
